import { render, staticRenderFns } from "./publicactive.vue?vue&type=template&id=5d6dbf86&scoped=true&"
import script from "./publicactive.vue?vue&type=script&lang=js&"
export * from "./publicactive.vue?vue&type=script&lang=js&"
import style0 from "./publicactive.vue?vue&type=style&index=0&id=5d6dbf86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6dbf86",
  null
  
)

export default component.exports